<template>
<div>
  <div class="wistia_embed wistia_async_21blt968ge">
    &nbsp;
  </div>

  <div
    id="choose_administrator"
    class="tbk-vid-embed"
  >
    <a
      id="understanding_cecilia"
      class="embedded_video"
      href="#wistia_r15z3i6uay?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_fatuma"
      class="embedded_video"
      href="#wistia_aahd8ndeym?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_julia"
      class="embedded_video"
      href="#wistia_mflwepk5uy?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>

    <a
      id="understanding_patina"
      class="embedded_video"
      href="#wistia_ofqpyshv21?videoFoam=true"
    >
      &nbsp;
    </a>
    <br>
  </div>
</div>
</template>

<script>
import TbkVideoMixin from './TbkVideoMixin'

export default {
  mixins: [TbkVideoMixin],

  mounted() {
    this.tbk.loadCrossTime('21b', 0, this.showSelect)

    this.tbk.loadCrossTime('r15', 114, this.showSelect)
    this.tbk.loadCrossTime('aah', 129, this.showSelect)
    this.tbk.loadCrossTime('mfl', 76, this.showSelect)
    this.tbk.loadCrossTime('ofq', 99, this.showSelect)

    if (this.tbk.isMobile()) {
      _wq.push({
        r15: this.tbk.autoPlay,
        aah: this.tbk.autoPlay,
        mfl: this.tbk.autoPlay,
        ofq: this.tbk.autoPlay
      })
    }
  },

  methods: {
    showSelect() {
      $('.tbk-vid-embed').show()
      this.tbk.hideMobileControls()
    }
  }
}
</script>

<style scoped lang="sass">
#choose_administrator
  display: none
  a
    text-decoration: none
#understanding_cecilia
  position: absolute
  top: 0
  left: 0
  width: 25%
  height: 100%
#understanding_fatuma
  position: absolute
  top: 0
  left: 25%
  width: 25%
  height: 100%
#understanding_julia
  position: absolute
  top: 0
  left: 50%
  width: 25%
  height: 100%
#understanding_patina
  position: absolute
  top: 0
  left: 75%
  width: 25%
  height: 100%
</style>
